import { mapEnumToOptions } from '@abp/ng.core';

export enum AnswerGroupState {
  Inactive = 0,
  Active = 1,
}

export const answerGroupStateOptions = mapEnumToOptions(AnswerGroupState);
